module.exports = __webpack_public_path__ + "img/1512701482.15f65855.jpg";